import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import moment from "moment";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import { useEffect } from "react";

const R12DassInformation = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    getyear,
    subFormLevels,
    formData: {
      firstName,
      beenExpelled,
      expelledFromWhichSchool,
      expelledWhatYear,
      moreThanThreeUnexcusedAbsences,
      beenSuspended,
      suspendedFromWhichSchool,
      suspendedWhatYear,
      onProbation,
      isParentOrExpecting,
      lateToSchoolMoreThanThreeTimes,
      orderedToAttendSchool,
      orderedToAttendWhichSchool,
      orderedToAttendWhatYear,
      retainedMoreThanOnce,
      retainedFromWhichSchool,
      retainedFromWhatYear,
      droppedOutOfSchool,
      droppedOutFromWhichSchool,
      droppedOutFromWhatYear,
      behindSemesterInCredits,
      outOfSchoolMoreThanFortyFiveDays,
      expelledMoreThanTwoSchoolsPastYear,
      youthExperiencingHomelessness,
      fosterCare,
    },
    onFormDataChange,
    pass: { dassInformation1 },
  } = registrationContext;

  const dassInformation2 =
    (beenExpelled["no"] ||
      (beenExpelled["yes"] &&
        expelledFromWhichSchool !== "" &&
        expelledWhatYear !== "")) &&
    onProbation !== "" &&
    (beenSuspended["no"] ||
      (beenSuspended["yes"] &&
        suspendedFromWhichSchool !== "" &&
        suspendedWhatYear !== "")) &&
    isParentOrExpecting !== "" &&
    (orderedToAttendSchool["no"] ||
      (orderedToAttendSchool["yes"] &&
        orderedToAttendWhichSchool !== "" &&
        orderedToAttendWhatYear !== "")) &&
    moreThanThreeUnexcusedAbsences !== "" &&
    lateToSchoolMoreThanThreeTimes !== "" &&
    (retainedMoreThanOnce["no"] ||
      (retainedMoreThanOnce["yes"] &&
        retainedMoreThanOnce !== "" &&
        retainedFromWhichSchool !== "")) &&
    (droppedOutOfSchool["no"] ||
      (droppedOutOfSchool["yes"] &&
        droppedOutFromWhichSchool !== "" &&
        droppedOutFromWhatYear !== "")) &&
    behindSemesterInCredits !== "" &&
    expelledMoreThanTwoSchoolsPastYear !== "" &&
    outOfSchoolMoreThanFortyFiveDays !== "" &&
    youthExperiencingHomelessness !== "" &&
    fosterCare !== "";

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          DASS Information <span>(11/15)</span>
          <hr />
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? " Student" : firstName} Ever Been Expelled
              From Any School for Any Reason?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : beenExpelled !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={beenExpelled["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenExpelled"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={beenExpelled["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenExpelled"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        {beenExpelled["yes"] && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>From Which School?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="expelledFromWhichSchool"
                onChange={(e) => handleChange(e)}
                value={expelledFromWhichSchool}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : expelledFromWhichSchool !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Which Year?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="expelledWhatYear"
                max="4"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={expelledWhatYear}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : expelledWhatYear !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          </>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? " Student" : firstName} Ever Been
              Suspended for More Than 10 Days in Any School Year?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : beenSuspended !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={beenSuspended["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenSuspended"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={beenSuspended["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="beenSuspended"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {beenSuspended["yes"] && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>From Which School?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suspendedFromWhichSchool"
                // onChange={(e) => {
                //   onFormDataChange(e);
                // }}
                onChange={(e) => handleChange(e)}
                value={suspendedFromWhichSchool}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : suspendedFromWhichSchool !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Which Year?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suspendedWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={suspendedWhatYear}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : suspendedWhatYear !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          </>
        )}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName} on Probation?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : onProbation !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={onProbation["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="onProbation"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={onProbation["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="onProbation"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName} a Parent (Mother
              or Father) or Expecting a Child Soon?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : isParentOrExpecting !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={isParentOrExpecting["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="isParentOrExpecting"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={isParentOrExpecting["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="isParentOrExpecting"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Had More Than 3
              Unexcused Absences in a School Year?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : moreThanThreeUnexcusedAbsences !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={moreThanThreeUnexcusedAbsences["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="moreThanThreeUnexcusedAbsences"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={moreThanThreeUnexcusedAbsences["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="moreThanThreeUnexcusedAbsences"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Been 30 Minutes
              Late to School 3 or More Times in a School Year?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : lateToSchoolMoreThanThreeTimes !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={lateToSchoolMoreThanThreeTimes["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="lateToSchoolMoreThanThreeTimes"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={lateToSchoolMoreThanThreeTimes["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="lateToSchoolMoreThanThreeTimes"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Ever Been
              Ordered To Attend School by a Review Board or Probation Officer?{" "}
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </h3>
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : orderedToAttendSchool !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={orderedToAttendSchool["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="orderedToAttendSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={orderedToAttendSchool["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="orderedToAttendSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {orderedToAttendSchool["yes"] && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>From Which School?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="orderedToAttendWhichSchool"
                onChange={(e) => handleChange(e)}
                value={orderedToAttendWhichSchool}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : orderedToAttendWhichSchool !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Which Year?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="orderedToAttendWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={orderedToAttendWhatYear}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : orderedToAttendWhatYear !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          </>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Was {firstName === "" ? "the Student" : firstName} Retained (Held
              Back) More Than Once in Grades K-8?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : retainedMoreThanOnce !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={retainedMoreThanOnce["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="retainedMoreThanOnce"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={retainedMoreThanOnce["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="retainedMoreThanOnce"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {retainedMoreThanOnce["yes"] && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>From Which School?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="retainedFromWhichSchool"
                onChange={(e) => handleChange(e)}
                value={retainedFromWhichSchool}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : retainedFromWhichSchool !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Which Year?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="retainedFromWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={retainedFromWhatYear}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : retainedFromWhatYear !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          </>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Ever Dropped
              Out of School?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : droppedOutOfSchool !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={droppedOutOfSchool["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="droppedOutOfSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={droppedOutOfSchool["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="droppedOutOfSchool"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        {droppedOutOfSchool["yes"] && (
          <>
            <div className="item">
              <div className="asterisk-group">
                <h3>From Which School?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="droppedOutFromWhichSchool"
                onChange={(e) => handleChange(e)}
                value={droppedOutFromWhichSchool}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : droppedOutFromWhichSchool !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>

            <div className="item">
              <div className="asterisk-group">
                <h3>Which Year?</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="droppedOutFromWhatYear"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={droppedOutFromWhatYear}
                style={{
                  border: dassInformation1
                    ? "1px solid #ccc;"
                    : droppedOutFromWhatYear !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          </>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName} Behind a
              Semester or More in Credits?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : behindSemesterInCredits !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={behindSemesterInCredits["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="behindSemesterInCredits"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={behindSemesterInCredits["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="behindSemesterInCredits"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Been Out of
              School for 45 Days or More Not Including Summer, Holiday Break,
              Off-Track or Any Other Days When a School Is Closed?
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </h3>
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : outOfSchoolMoreThanFortyFiveDays !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={outOfSchoolMoreThanFortyFiveDays["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="outOfSchoolMoreThanFortyFiveDays"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={outOfSchoolMoreThanFortyFiveDays["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="outOfSchoolMoreThanFortyFiveDays"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Been Enrolled
              in More Than 2 Schools During the Past Academic Year or Has
              Changed Schools More Than Two Times Since Entering High School?{" "}
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </h3>
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : expelledMoreThanTwoSchoolsPastYear !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={expelledMoreThanTwoSchoolsPastYear["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="expelledMoreThanTwoSchoolsPastYear"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={expelledMoreThanTwoSchoolsPastYear["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="expelledMoreThanTwoSchoolsPastYear"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName} in Foster Care?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : fosterCare !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={fosterCare["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="fosterCare"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={fosterCare["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="fosterCare"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName} a Youth
              Experiencing Homelessness?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: dassInformation1
                ? "1px solid #ccc;"
                : youthExperiencingHomelessness !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={youthExperiencingHomelessness["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="youthExperiencingHomelessness"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={youthExperiencingHomelessness["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="youthExperiencingHomelessness"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="group">{subFormLevels.dassInformation === 0}</div>
      </div>
      <ProgressButtons validation={dassInformation2} name="dassInformation1" />
    </>
  );
};

export default R12DassInformation;
